import PeopleIcon from '@mui/icons-material/People';

export const Community = () => <PeopleIcon fontSize="medium" />;
